import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useDialogPluginComponent } from 'quasar'
import BaseDialogContent from 'src/apps/core/components/BaseDialogContent.vue'
import { truncate } from 'src/etc/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvertAdminDialog',
  props: {
  advert: {
    type: Object,
    required: true
  }
},
  emits: [
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
],
  setup(__props) {





const { dialogRef, onDialogHide } = useDialogPluginComponent()
// dialogRef      - Vue ref to be applied to QDialog
// onDialogHide   - Function to be used as handler for @hide on QDialog
// onDialogOK     - Function to call to settle dialog with "ok" outcome
//                    example: onDialogOK() - no payload
//                    example: onDialogOK({ /*...*/ }) - with payload
// onDialogCancel - Function to call to settle dialog with "cancel" outcome

// this is part of our example (so not required)
// function onOKClick() {
//   // on OK, it is REQUIRED to
//   // call onDialogOK (with optional payload)
//   onDialogOK()
//   // or with payload: onDialogOK({ ... })
//   // ...and it will also hide the dialog automatically
// }

return (_ctx: any,_cache: any) => {
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(BaseDialogContent, {
        "hide-header-separator": "",
        "header-label": _unref(truncate)(`${__props.advert.title}`, 40)
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Ranking Score: " + _toDisplayString(__props.advert.rec_score), 1)
        ]),
        _: 1
      }, 8, ["header-label"])
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})